export default __webpack_public_path__ + "static/media/43724.5270fb69.jpg";